import React from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import chevron from 'chevron-small.svg';
import defaultImage from 'default_listing_image.svg';
import ErrorBoundary from './ErrorBoundary';

function CategoryCard({ name, image, page }) {
  return (
    <a
      href={`${window.location.pathname}/${page}`}
      className="category-card"
      aria-label={`Filter by ${name}`}
      data-turbolinks="false"
    >
      <div className="image-container">
        <img
          data-src={image || defaultImage}
          className="lazyload"
          alt={`${name} Category`}
          title={`${name} Category`}
          aria-label={`${name} Category`}
        />
      </div>
      <div>
        <p>{name}</p>
        <ReactSVG className="chevron" src={chevron} />
      </div>
    </a>
  );
}

CategoryCard.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
  page: PropTypes.string.isRequired,
};

function CategoryCardWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <CategoryCard {...props} />
    </ErrorBoundary>
  );
}

export default CategoryCardWrapper;
